import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, CheckCircle, Home, RotateCcw } from "lucide-react";

const ThankYou = () => {
  return (
    <div className="max-w-2xl mx-auto px-4 py-16">
      <div className="text-center">
        <div className="inline-flex items-center justify-center p-4 bg-green-500 rounded-full mb-6">
          <CheckCircle className="h-12 w-12 text-white" />
        </div>

        <h1 dir="rtl" className="text-3xl font-bold text-gray-800 mb-4">
          יש לנו את זה!
        </h1>

        <p dir="rtl" className="text-lg text-gray-600 mb-8">
          שמרנו את המימז שלך! יש לנו אותו ונדפיס אותו לחתונה
          <br />
          <i className="text-gray-600 text-xs">
            (עד כדי חוסר מקום או שטלי תחליט שהוא לא מתאים לאירוע ט.ל.ח)
          </i>
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Link
            to="/"
            className="inline-flex items-center space-x-2 bg-pink-500 text-white px-6 py-3 rounded-lg font-medium hover:bg-pink-600 transition-colors"
          >
            <span dir="rtl">רוצה להכין עוד אחד?</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ThankYou;
